




import { Component, Vue } from 'vue-property-decorator';
import userList from '@/components/users/user-list.component.vue'; // ユーザ一覧

@Component({
  components: {
    'user-list': userList
  }
})
export default class List extends Vue {}
